import api from "@/services/api.service";
import { required } from "vuelidate/lib/validators";

export default {
  name: "edit",
  components: {},
  props: {},
  data() {
    return {
      caption: "Edit Agent",
      vendors: [],
      formField: {
        tags: [],
        user_id: "",
        contact_values: {},
        marketing_event_id: "",
        type:""
      },
      submitStatus: null,
      filterCriteria: [{ columns: null, text_value: null }],
      map_headers: [],
      concateColumn: [{ name: null, columns: [null] }],
      selectedHeadersShow: [],
      checkedHeaders: [],
      existing_tags: [],
      tags: [],
      removed_tags: []
    };
  },
  computed: {},
  mounted() {},
  validations: {
    formField: {
      user_id: {
        required
      },
      type: {
        required
      },
      tags: {
        required
      }
    }
  },
  created() {
    this.getVendors();
    this.getColumns();
    this.getTags();
    this.getAgentMarketingData();
  },
  methods: {
    makeToast(message = "", title = "Alert", variant = "warning") {
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
        title: title,
        variant: variant,
        autoHideDelay: 3000
      });
    },
    async getTags() {
      let response = await api.post("tags/list");
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
          );
      if (response.status == "success") {
        response.data.forEach(
          function(e) {
            this.existing_tags.push({ key: e.tags.substring(0, 100), value: e.tags.substring(0, 100) });
          }.bind(this)
          );
      }
    },
    async getAgentMarketingData() {
      let response = await api.post("admin/marketing-event/agent/list", {
        id: this.$route.params.agent_req_id
      });
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
          );
      if (response.status == "success") {
        if (response.data != "") {
          this.formField.user_id = response.data.user_id;
          this.formField.marketing_event_id = response.data.marketing_event_id;
          var contact_values = JSON.parse(response.data.contact_values);

          response.data.tags.forEach(
            function(e) {
              this.tags.push({ id: e.id, value: e.tags });
            }.bind(this)
            );

          this.filterCriteria = contact_values.filter_criteria;
          this.formField.type = contact_values.match_with;

          contact_values.selected_column.forEach(
            function(element) {
              this.checkedHeaders[element.value] = element.value;
              this.selectedHeadersShow.push({
                text: element.text,
                value: element.value
              });
            }.bind(this)
            );

          this.concateColumn = contact_values.concate_column;

          this.formField.tags = this.tags;
        } else {
          this.makeToast(`No vendor found.`, "Alert", "danger");
        }
      } else this.makeToast(`No vendor found.`, "Alert", "danger");
    },

    async getColumns() {

     var response = await  api.post('admin/mapping_headers/list')
     if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)
    if (response.status == 'success') {
      if (response.data != '') {          
        response.data.data.forEach(function(e){                      
          this.map_headers.push({value:e.column_key,text:e.column});
        }.bind(this));                           
      } else {
        this.map_headers = [];
        this.makeToast(`No database headers found.`, 'Alert', 'danger')
      }
    } else
    this.makeToast(`No database headers found.`, 'Alert', 'danger');
      /*var response = await api.post("admin/marketing-event/agent/headers-list",{ marketing_event_id: this.$route.params.id });
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
        );
      if (response.status == "success") {
        if (response.data != "") {
          this.map_headers = response.data;
          console.log(this.map_headers)
        } else {
          this.map_headers = [];
          this.makeToast(`No database headers found.`, "Alert", "danger");
        }
      } else this.makeToast(`No database headers found.`, "Alert", "danger");*/
    },
    addFilterCriteria() {
      this.filterCriteria.push({ columns: null, text_value: null });
    },
    deleteFilterCriteria(index) {
      this.filterCriteria.splice(index, 1);
    },
    addConcateColumn() {
      this.concateColumn.push({ columns: [null], name: null });
    },
    deleteConcateColumn(index) {
      this.concateColumn.splice(index, 1);
    },
    addColumns(index) {
      this.concateColumn[index].columns.push(null);
    },
    deleteColumn(index, idx) {
      this.concateColumn[index].columns.splice(idx, 1);
    },
    inArray: function(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i].value == needle) return i;
      }
      return false;
    },
    selectedHeaders(index) {
      var is_value = this.inArray(
        this.map_headers[index].value,
        this.selectedHeadersShow
        );
      if (is_value !== false) {
        this.selectedHeadersShow.splice(is_value, 1);
      } else {
        this.selectedHeadersShow.push(this.map_headers[index]);
      }
    },
    async getVendors() {
      let response = await api.post("users/get-user-List", { type: "agent" });
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);

      if (response.status == "success") {
        if (response.data != "") {
          response.data.forEach(
            function(e) {
              this.vendors.push({
                value: e.id,
                text: e.first_name + " " + e.last_name
              });
            }.bind(this)
            );
        } else {
          this.campaigns = [];
          this.makeToast(`Agent not found.`, "Alert", "danger");
        }
      }
    },
    onTagRemoved(tag) {
      this.removed_tags.push(tag.id);
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {

       if (this.filterCriteria[0].columns === null || this.filterCriteria[0].text_value === null) {
        this.makeToast("Please, fill search criteria","Alert","danger",6000);
        return;
      }
      if (this.selectedHeadersShow.length === 0) {
        this.makeToast("Please, select any columns","Alert","danger",6000);
        return;
      }

      this.formField.id = this.$route.params.agent_req_id;
      this.formField.removed_tags = this.removed_tags;
      this.formField.user_type = "agent";
      this.formField.contact_values = {
        filter_criteria: this.filterCriteria,
        concate_column: (this.concateColumn || this.concateColumn[0].name !== null ? this.concateColumn : []),
        selected_column:this.selectedHeadersShow.length != 0 ? this.selectedHeadersShow : [],
        match_with:this.formField.type
      };

      let response = await api.post(
        "admin/marketing-event/edit-vendor",
        this.formField
        );
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
          );

      if (response.status == "success") {
        this.makeToast(response.message, "Success", "success");
        this.$router.push({ name: "List Event" });
      } else {
        for (var error in response.errors) {
          this.makeToast(response.errors[error], "Alert", "danger");
        }
      }
    }
  }
}
};
